{
  "instances": {
    "threaddump": {
      "label": "執行緒傾印",
      "download": "下載執行緒傾印",

      "download_failed": "下載執行緒傾印失敗。",
      "thread_details_blocked_count": "阻塞次數",
      "thread_details_blocked_time": "阻塞時間",
      "thread_details_lock_name": "Lock 名稱",
      "thread_details_lock_owner_id": "Lock 擁有者 ID",
      "thread_details_lock_owner_name": "Lock 擁有者名稱",
      "thread_details_waited_count": "等待次數",
      "thread_details_waited_time": "等待時間",
      "thread_id": "執行緒 ID",
      "thread_name": "執行緒名稱",
      "thread_state": "執行緒狀態"
    }
  }
}
